import React from 'react';
import { kebabCase } from 'lodash';
import { ReactComponent as WeirdCircleThing } from 'assets/weird-circle-thing.svg';
import './FacebookPagePreview.pcss';
import mmCoverPhoto from 'assets/mm-cover-photo.png';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import MessengerIcon from '../../../../dashboard/pages/RegisterFlow/ConnectFacebook/MessengerIcon';
import { ImageWithFallback } from '../../../../common/components/ImageWithFallback/ImageWithFallback';

type Props = {
  facebookPage: ConnectedPageModel;
};

export const FacebookPagePreview = (props: Props) => {
  const { facebookPage } = props;
  const atName = `@${kebabCase(facebookPage.name || 'N/A')}`;
  const coverPhoto = facebookPage.coverPhoto || mmCoverPhoto;

  return (
    <div className="facebook-page-preview">
      <div className="facebook-page-preview__left">
        <img
          alt="Facebook Page Profile"
          className="facebook-page-preview__profile-image"
          src={facebookPage.squarePicture}
        />

        <div className="facebook-page-preview__name">{facebookPage.name}</div>

        <div className="facebook-page-preview__at-handle">{atName}</div>

        <div className="facebook-page-preview__side-menu">
          <div className="facebook-page-preview__side-menu-item facebook-page-preview--active-side-menu-item">
            Home
          </div>

          <div className="facebook-page-preview__side-menu-item">Posts</div>

          <div className="facebook-page-preview__side-menu-item">Reviews</div>
        </div>
      </div>

      <div className="facebook-page-preview__right">
        <ImageWithFallback
          alt="Facebook Page Cover Photo"
          className="facebook-page-preview__cover-photo"
          src={coverPhoto}
          fallbackImage={mmCoverPhoto}
        />

        <div className="facebook-page-preview__right-bottom">
          <div className="facebook-page-preview__page-button-container">
            <div className="facebook-page-preview__page-button">
              <i className="fas fa-thumbs-up" />
              <span className="facebook-page-preview__page-button-text">
                Like
              </span>
            </div>

            <div className="facebook-page-preview__page-button">
              <i className="fas fa-rss" />
              <span className="facebook-page-preview__page-button-text">
                Following
              </span>
            </div>

            <div className="facebook-page-preview__page-button">
              <i className="fas fa-share" />
              <span className="facebook-page-preview__page-button-text">
                Share
              </span>
            </div>

            <div className="facebook-page-preview__page-button">
              <i className="fas fa-ellipsis-h facebook-page-preview__ellipsis" />
            </div>
          </div>

          <div className="facebook-page-preview__send-message-button">
            <MessengerIcon
              color="#0084ff"
              className="facebook-page-preview__messenger-icon"
              hoverColor="#fff"
              size={20}
            />
            <span>Send Message</span>
          </div>

          <WeirdCircleThing className="facebook-page-preview__weird-circle-thing" />
        </div>
      </div>

      <div className="facebook-page-preview__overlay">
        <div className="facebook-page-preview__overlay-center" />
      </div>
    </div>
  );
};
